<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="560px"
    :close-on-click-modal="false"
    class="app-main-inner edi-error-log-dialog"
  >
    <div class="app-main-inner-row row-grid-dialog" style="padding-top: 0;">
      <pre>{{ errorLog }}</pre>
    </div>
    <div slot="footer">
      <el-button no="close" @click="close">{{ $t('common.btn.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/lang'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'ErrorLogDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: i18n.t('SeaExport.BookingDataFeedback') },
    errorLog: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.edi-error-log-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
